import type { SVGProps } from 'react';
import { SohanemonsLogo } from './icons';

export const Icons = {
	sohanscript: (props: SVGProps<SVGSVGElement>) => (
		<svg
			width="195"
			height="248"
			viewBox="0 0 195 248"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<rect
				x="97.5"
				y="98.5654"
				width="36"
				height="36"
				transform="rotate(45 97.5 98.5654)"
				fill="#6FCBFF"
			/>
			<path
				d="M96 221.562L43.5001 221.562L141.081 123.981L193.213 123.981L96 221.562Z"
				fill="#6FCBFF"
			/>
			<path
				d="M53.5007 124.02L1 124.021L99.0811 25.9791L151 25.9791L53.5007 124.02Z"
				fill="#6FCBFF"
			/>
			<path
				d="M2.00025 123.021H194.168L192.172 125.021H0L2.00025 123.021Z"
				fill="#6FCBFF"
			/>
		</svg>
	),
	brand: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 887 797"
			width={887}
			height={797}
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				stroke="#fff"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={52}
				d="M278.955.912 55.7 71.002.514 276.96m830.449 139.153 55.186-205.956L718.028 74.484M127.155 660.435l168.069 135.866 223.307-70.285m165.035-147.592 89.098-332.52-271.208-219.27-360.359 113.442-89.098 332.52 271.26 219.077 360.307-113.249Z"
			/>
		</svg>
	),
	brandAnimated: (props: SVGProps<SVGSVGElement>) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 887 797"
			width={887}
			height={797}
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				stroke="#fff"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={52}
				d="M278.955.912 55.7 71.002.514 276.96m830.449 139.153 55.186-205.956L718.028 74.484M127.155 660.435l168.069 135.866 223.307-70.285m165.035-147.592 89.098-332.52-271.208-219.27-360.359 113.442-89.098 332.52 271.26 219.077 360.307-113.249Z"
			/>
		</svg>
	),
	star: (props: SVGProps<SVGSVGElement>) => (
		<svg
			viewBox="0 0 24 24"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<title>star</title>
			<path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14 2 9.27l6.91-1.01L12 2z" />
		</svg>
	),
	sohanemon: SohanemonsLogo,
};
